export default "__VITE_ASSET__DztJXTdr__"